let _Vue

function install(Vue) {
  if (install.installed && _Vue === Vue) return
  install.installed = true

  _Vue = Vue

  Vue.directive('visible', {
    inserted: (el, binding, vnode) => {
      const { context } = vnode
      const { hiddenModules } = context
      let value = binding.value
      value = typeof value === 'number' ? value + '' : value
      if (hiddenModules) {
        // 如果传入字符串包含在 hiddenModules 中则移除改元素
        if (hiddenModules.includes(value)) {
          if (el.parentNode) {
            el.parentNode.removeChild(el)
          }
        }
      }
    }
  })
}

export default install
